var _linearGradient, _clipPath, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllustrator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 119,
    height: 20,
    role: "img",
    "aria-label": "adobe illustrator",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "adobe illustrator") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x2: 0,
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bbb",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 119,
    height: 20,
    rx: 3,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0,
    height: 20,
    fill: "#555"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 119,
    height: 20,
    fill: "#ff9a00"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 119,
    height: 20,
    fill: "url(#s)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    textAnchor: "middle",
    fontFamily: "Verdana,Geneva,DejaVu Sans,sans-serif",
    textRendering: "geometricPrecision",
    fontSize: 110
  }, /*#__PURE__*/React.createElement("image", {
    x: 5,
    y: 3,
    width: 14,
    height: 14,
    xlinkHref: "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJ3aGl0ZSIgcm9sZT0iaW1nIiB2aWV3Qm94PSIwIDAgMjQgMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHRpdGxlPkFkb2JlIElsbHVzdHJhdG9yPC90aXRsZT48cGF0aCBkPSJNMTAuNTMgMTAuNzNjLS4xLS4zMS0uMTktLjYxLS4yOS0uOTItLjEtLjMxLS4xOS0uNi0uMjctLjg5LS4wOC0uMjgtLjE1LS41NC0uMjItLjc4aC0uMDJjLS4wOS40My0uMi44Ni0uMzQgMS4yOS0uMTUuNDgtLjMuOTgtLjQ2IDEuNDgtLjE0LjUxLS4yOS45OC0uNDQgMS40aDIuNTRjLS4wNi0uMjExLS4xNC0uNDYtLjIzLS43MjEtLjA5LS4yNjktLjE4LS41NTktLjI3LS44NTl6TTE5Ljc1LjNINC4yNUMxLjkuMyAwIDIuMiAwIDQuNTV2MTQuOWMwIDIuMzUgMS45IDQuMjUgNC4yNSA0LjI1aDE1LjVjMi4zNSAwIDQuMjUtMS45IDQuMjUtNC4yNVY0LjU1QzI0IDIuMiAyMi4xLjMgMTkuNzUuM3pNMTQuNyAxNi44M2gtMi4wOTFjLS4wNjkuMDEtLjEzOS0uMDQtLjE1OS0uMTFsLS44Mi0yLjM4SDcuOTFsLS43NiAyLjM1Yy0uMDIuMDktLjEuMTUtLjE5LjE0MUg1LjA4Yy0uMTEgMC0uMTQtLjA2MS0uMTEtLjE4TDguMTkgNy4zOGMuMDMtLjEuMDYtLjIxLjEtLjMzLjA0LS4yMS4wNi0uNDMuMDYtLjY1LS4wMS0uMDUuMDMtLjEuMDgtLjExaDIuNTljLjA4IDAgLjEyLjAzLjEzLjA4bDMuNjUgMTAuM2MuMDMuMTA5IDAgLjE2LS4xLjE2em0zLjQtLjE1YzAgLjExLS4wMzkuMTYtLjEyOS4xNkgxNi4wMWMtLjEgMC0uMTUtLjA2MS0uMTUtLjE2di03LjdjMC0uMS4wNDEtLjE0LjEzMS0uMTRoMS45OGMuMDkgMCAuMTI5LjA1LjEyOS4xNHY3Ljd6bS0uMjA5LTkuMDNjLS4yMzEuMjQtLjU3MS4zNy0uOTExLjM1LS4zMy4wMS0uNjUtLjEyLS44OTEtLjM1LS4yMy0uMjUtLjM1LS41OC0uMzQtLjkyLS4wMS0uMzQuMTItLjY2LjM1OS0uODkuMjQyLS4yMy41NjItLjM1Ljg5Mi0uMzUuMzkxIDAgLjY4OS4xMi45MS4zNS4yMi4yNC4zNC41Ni4zMy44OS4wMS4zNC0uMTEuNjctLjM0OS45MnoiLz48L3N2Zz4="
  }), /*#__PURE__*/React.createElement("text", {
    "aria-hidden": "true",
    x: 685,
    y: 150,
    fill: "#010101",
    fillOpacity: 0.3,
    transform: "scale(.1)",
    textLength: 910
  }, "adobe illustrator"), /*#__PURE__*/React.createElement("text", {
    x: 685,
    y: 140,
    transform: "scale(.1)",
    fill: "#fff",
    textLength: 910
  }, "adobe illustrator"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrator);
export default __webpack_public_path__ + "static/media/illustrator.ac45208c38a5f0ef295f583668a1dce8.svg";
export { ForwardRef as ReactComponent };